<script setup lang="ts">
import { IconPower } from '@tabler/icons-vue';
import { useRouter } from 'vue-router';
import LogoutConfirmation from '@/components/modals/LogoutConfirmation.vue';
import { useAuthStore } from '@/stores/auth';
import Logo from '/public/images/logos/snapei-b2b-logo.svg';

const authStore = useAuthStore();
</script>

<template>
  <!-- Oculto para el rol Admin: el logout ya está en el menú superior (evita duplicado). -->
  <v-sheet v-if="!authStore.isAdmin" rounded="md" color="lightsecondary" class="px-4 py-3 ExtraBox">
    <div class="d-flex align-center hide-menu">
      <VImg :src="Logo" height="32" width="130" />
      <div class="ml-auto">
        <v-btn
          variant="text"
          icon
          rounded="md"
          color="primary"
          @click="authStore.initiateLogout('profile-btn-logout-click()')"
        >
          <IconPower />
          <v-tooltip activator="parent" location="top">{{ $t('Logout') }}</v-tooltip>
        </v-btn>
      </div>
    </div>
    <LogoutConfirmation :open="true" />
  </v-sheet>
</template>
<style lang="scss">
.ExtraBox {
  position: relative;
  overflow: hidden;
}
.line-height-none {
  line-height: normal;
}
</style>
